/** Parametrização do faturamento (modelo Gett › Faturamento › Parametrizações). Alíquotas em % (4 = 4%). */
export interface FiscalRates {
  cfop?: string | null;
  cstIcms?: string | null;
  icmsPercent?: number | null;
  /** Redução da base do ICMS próprio (%). */
  icmsBaseReductionPercent?: number | null;
  /** Redução da base do ICMS ST (%). */
  stBaseReductionPercent?: number | null;
  /** Alíquota interna do ICMS ST no destino (%). */
  stInternalPercent?: number | null;
  mvaPercent?: number | null;
  ipiPercent?: number | null;
  pisPercent?: number | null;
  cofinsPercent?: number | null;
  fcpPercent?: number | null;
  fcpStPercent?: number | null;
  difalInternalPercent?: number | null;
  difalInterstatePercent?: number | null;
  difalFcpPercent?: number | null;
  presumedCreditCode?: string | null;
  /** Crédito presumido (% do ICMS destacado). */
  presumedCreditPercent?: number | null;
  ibsStatePercent?: number | null;
  ibsCityPercent?: number | null;
  cbsPercent?: number | null;
  cestCode?: string | null;
}

export interface BillingSettingException {
  id?: string;
  /** 8 dígitos. */
  ncm?: string | null;
  /** UF do cliente. */
  state?: string | null;
  customerName?: string | null;
  /** Exceção por produto do Gett: guardada, mas não aplicada no simulador. */
  productDescription?: string | null;
  rates: FiscalRates;
}

export type BillingSettingKind = "encomenda" | "contaOrdem" | "venda" | "outra";

export const billingKindLabels: Record<BillingSettingKind, string> = {
  encomenda: "Encomenda",
  contaOrdem: "Conta e ordem",
  venda: "Venda própria",
  outra: "Outra",
};

export interface BillingSetting {
  id?: string;
  gettId?: number | null;
  name: string;
  kind: BillingSettingKind;
  unitType?: number | null;
  unitState?: string | null;
  natureOperation?: string | null;
  isEndCustomer: boolean;
  notes?: string | null;
  commercialClientId?: string | null;
  companyId?: string | null;
  clientName?: string | null;
  exceptionCount: number;
  rates: FiscalRates;
  /** Só no detalhe. */
  exceptions?: BillingSettingException[];
}

export interface BillingSettingImportResult {
  created: number;
  updated: number;
  exceptions: number;
  linked: number;
}
